import { Award, Trophy } from "lucide-react";
import { motion } from "framer-motion";
import { awards, achievements } from "../data/profile";
import { Reveal, Overline, AnimatedHeading } from "./Reveal";

export const Awards = () => (
  <section id="awards" className="py-16 sm:py-20 lg:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <Overline>Honours & Recognition</Overline>
        <AnimatedHeading className="font-display text-3xl sm:text-4xl font-bold text-navy tracking-tight mt-4">
          Awards & Achievements
        </AnimatedHeading>
        <p className="mt-4 text-lg" style={{ color: "#4B5A69" }}>
          Nationally and internationally recognised for excellence in healthcare quality and public health.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {awards.map((a, i) => (
          <Reveal key={i} delay={i * 0.05}>
            <div
              data-testid={`award-card-${i}`}
              className="group h-full bg-white border border-[#E2E5E1] rounded-2xl p-7 hover:-translate-y-2 hover:border-gold hover:shadow-[0_24px_40px_-24px_rgba(163,139,93,0.5)] transition-all duration-300"
            >
              <div className="flex items-center justify-between">
                <Award size={26} className="text-gold group-hover:scale-125 group-hover:-rotate-12 transition-transform duration-300" />
                <span className="text-xs font-plex font-semibold text-navy/40">{a.year}</span>
              </div>
              <h3 className="font-display text-lg font-bold text-navy mt-5 leading-snug">{a.title}</h3>
              <p className="mt-2 text-sm leading-relaxed" style={{ color: "#4B5A69" }}>{a.sub}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-16">
        <div className="bg-navy rounded-3xl p-8 sm:p-12 text-bone overflow-hidden relative">
          <div className="absolute -top-16 -right-16 h-64 w-64 rounded-full bg-teal/20 blur-3xl" />
          <div className="flex items-center gap-3 relative">
            <Trophy className="text-gold animate-float" size={26} />
            <h3 className="font-display text-2xl font-bold">Landmark Achievements</h3>
          </div>
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-5 relative">
            {achievements.map((ac, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.08 }}
                className="flex items-start gap-3.5 group"
                data-testid={`achievement-${i}`}
              >
                <span className="mt-1.5 h-3 w-3 rotate-45 bg-gradient-to-br from-gold to-gold/40 shrink-0 transition-all duration-500 group-hover:rotate-[225deg] group-hover:scale-125 group-hover:from-gold group-hover:to-teal" />
                <p className="text-sm leading-relaxed text-bone/85 group-hover:text-bone group-hover:translate-x-1 transition-all duration-300">{ac}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
